import { WHATS_NEW } from '../whats-new.js'
import { useT } from './i18n-context.js'

/**
 * «Что нового» — несколько последних выпусков человеческими словами.
 *
 * Открывается из меню и только оттуда: без уведомлений, значков
 * и «у вас новое». Человек, который заметил перемену, знает, куда
 * заглянуть, а остальным экран не мешает.
 */
export function WhatsNewScreen({ onBack }: { readonly onBack: () => void }) {
  const t = useT()
  return (
    <section className="app-screen" aria-labelledby="whats-new-title">
      <h2 id="whats-new-title">{t('whatsNew.title')}</h2>
      <p className="app-field-hint">{t('whatsNew.hint')}</p>
      {WHATS_NEW.map((entry) => (
        <section
          key={entry.version}
          aria-labelledby={`whats-new-${entry.version}`}
          data-testid="whats-new-entry"
        >
          <h3 id={`whats-new-${entry.version}`}>
            {t('whatsNew.version', { version: entry.version, date: entry.date })}
          </h3>
          <ul className="app-list">
            {entry.items.map((key) => (
              <li key={key}>{t(`whatsNew.items.${key}`)}</li>
            ))}
          </ul>
        </section>
      ))}
      <div className="app-actions">
        <button type="button" className="app-button app-button-quiet" onClick={onBack}>
          {t('whatsNew.back')}
        </button>
      </div>
    </section>
  )
}
